<template>
  <div class="side-menu">
    <div
      class="open-panel control-btn"
      style="align-self: flex-end; margin: 5px"
      @click="$emit('closeMenu')"
    >
      <font-awesome-icon :icon="['fas', 'chevron-left']" />
    </div>
    <p class="menu-header">Detailed components</p>
    <div
      class="toolbox-item"
      v-for="toolboxItem in $toolbox.filter((x) => x.type === 'detail')"
      :key="toolboxItem.id"
      @click="openAdd(toolboxItem.id)"
    >
      <p class="toolbox-item-name">
        {{ toolboxItem.name.replace(/([A-Z])/g, " $1").trim() }}
      </p>
      <div v-if="currentAdd == toolboxItem.id">
        <input
          type="button"
          value="ADD"
          class="toolbox-btn"
          @click="addComponent(toolboxItem.id)"
        />
      </div>
    </div>
    <p class="menu-header break">High visibility components</p>
    <div
      class="toolbox-item"
      v-for="toolboxItem in $toolbox.filter((x) => x.type === 'visible')"
      :key="toolboxItem.id"
      @click="openAdd(toolboxItem.id)"
    >
      <p class="toolbox-item-name">
        {{ toolboxItem.name.replace(/([A-Z])/g, " $1").trim() }}
      </p>
      <div v-if="currentAdd == toolboxItem.id">
        <input
          type="button"
          value="ADD"
          class="toolbox-btn"
          @click="addComponent(toolboxItem.id)"
        />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      currentAdd: -1,
    };
  },
  methods: {
    openAdd(index) {
      if (this.currentAdd == index) this.currentAdd = "";
      else this.currentAdd = index;
    },

    addComponent(id) {
      var index = this.$toolbox.findIndex((x) => x.id == id);
      var moving = { ...this.$toolbox[index] };
      moving.config = { ...this.$toolbox[index].config };

      if (this.$store.getters.controls.length > 0) {
        moving.id =
          Math.max.apply(
            Math,
            this.$store.getters.controls.map(function (o) {
              return o.id;
            })
          ) + 1;
      } else {
        moving.id = 1;
      }

      this.$store.commit("addControl", moving);
      this.$emit("added")
    },
  },
};
</script>

<style scoped>
.side-menu {
  width: 250px;
  height: 100vh;
  background-color: #d8d8d8;
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right: 3px solid #303030;
  z-index: 8;
  overflow-y:auto;
}

.control-btn {
  border-radius: 6px;
  height: 36px;
  width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.3em;
  color: white;
  margin-right: 10px;
  cursor:pointer;
}

.menu-header {
  align-self: flex-start;
  margin: 10px 5px;
  font-weight: 700;
}

.open-panel {
  background-color: #303030;
}

.toolbox-item {
  width: 100%;
  background-color: #ffffff;
  border-top: 1px solid rgba(48, 48, 48, 0.3);
  border-bottom: 1px solid rgba(48, 48, 48, 0.3);
}

.toolbox-item-name {
  padding: 15px 0;
  cursor: pointer;
}

.toolbox-btn {
  width: 100%;
  background-color: #75eaff;
  color: #303030;
  border: 0;
  margin: 0;
  padding: 10px 0;
  letter-spacing: 2px;
  font-weight: 200;
  cursor: pointer;
}

.break {
  margin-top: 50px;
}
</style>